export default __webpack_public_path__ + "static/media/linux_process_metrics.0eea1baf.md";